import { FormTextField, IconButton, TextFieldProps } from 'omakase';
import { IconEye, IconEyeOff } from '@tock/icons';
import { IconMigrationUtil } from 'omakase/utils/IconMigrationUtil';
import { IconViewOff, IconViewOn } from 'ui/icons';
import React from 'react';

/**
 * Formik-ready text input password field
 */
const FormPasswordField: React.FunctionComponent<TextFieldProps> = ({
  name = 'password',
  id = 'password',
  placeholder = 'Password',
  label = 'Password',
  ...rest
}) => {
  const [showPassword, setShowPassword] = React.useState<boolean>(false);

  const handleClickShowPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  return (
    <FormTextField
      name={name}
      id={id}
      placeholder={placeholder}
      autoComplete="current-password"
      type={showPassword ? 'text' : 'password'}
      label={label}
      inputProps={{
        'data-testid': 'password-input',
      }}
      endAdornment={
        <IconButton
          data-testid="toggle-password-visibility"
          aria-label="toggle password visibility"
          onClick={handleClickShowPassword}
          onMouseDown={handleMouseDownPassword}
          size="small"
          variant="ghost"
          type="button"
        >
          {showPassword ? (
            <IconMigrationUtil legacyIcon={<IconViewOn />} newIcon={<IconEye />} />
          ) : (
            <IconMigrationUtil legacyIcon={<IconViewOff />} newIcon={<IconEyeOff />} />
          )}
        </IconButton>
      }
      {...rest}
    />
  );
};

export default FormPasswordField;
